import { GalleryUploader } from '../../../../components/admin/GalleryUploader';

export const AboutUsGalleryPage = () => (
  <GalleryUploader
    galleryName="ABOUT_US"
    title="About Us Images"
    description="Upload the main company image for the About Us page."
    itemType="IMAGE"
    multiple={false}
  />
);